import { Percomatic } from '@biggby-coffee/percomatic-typescript';
import { OrderItemFieldsFragment } from '../../../graphql';

export const castOrderModifier = (
	orderModifier: OrderItemFieldsFragment['modifiers'][number]
): Percomatic.Serialized.TransModifier => ({
	id: orderModifier.id,
	price: (orderModifier.price / 100).toFixed(2),
	quantity: orderModifier.quantity,
	modifier: {
		id: Number(orderModifier.modifier.id),
		isVariableQuantity: Boolean(orderModifier.modifier.isVariableQuantity),
		name: String(orderModifier.modifier.name),
		priority: Number(orderModifier.modifier.priority)
	}
});
